import React from 'react';
import { useNavigate } from 'react-router-dom';
import DarkModeToggle from '../DarkModeToggle/DarkModeToggle';
import './LessonTopBar.css';

const LessonTopBar = ({ currentScreenIndex, totalScreens, lessonTitle, screenTitle, progress }) => {
  const navigate = useNavigate();
  const progressPercentage = totalScreens > 0 ? ((currentScreenIndex + 1) / totalScreens) * 100 : 0;

  return (
    <div className="lesson-top-bar">
      <div className="top-bar-content">
        <div className="top-bar-left">
          <button 
            type="button" 
            className="back-button" 
            onClick={() => navigate('/dashboard')}
            title="Tilbake til oversikten"
          >
            ← Tilbake
          </button>
          <div>
          <h2 className="lesson-title">{lessonTitle}</h2>
          {screenTitle && (
            <p className="screen-title">{screenTitle}</p>
          )}

          </div>
        </div>
        <div className="top-bar-right">
          <DarkModeToggle />
          <div className="progress-indicator">
            <span className="step-counter">
              Steg {currentScreenIndex + 1} av {totalScreens}
            </span>
            <div className="progress-bar-container">
              <div 
                className="progress-bar-fill" 
                style={{ width: `${progressPercentage}%` }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LessonTopBar;
